// JA選択ポップアップ
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Heading from './Heading';
import Messages from './Messages';

interface Props {
  toggleShow: boolean;
  toggleClose: React.MouseEventHandler;
  popupClick: (ja_info: OfficeInfo) => void;
  office_list: OfficeInfo[];
  message: string;
}

interface OfficeInfo {
  id: string;
  name: string;
}

const SelectOffice: React.FC<Props> = ({
  toggleShow,
  toggleClose,
  popupClick,
  office_list,
  message,
}) => {
  return (
    <Modal
      size="lg"
      show={toggleShow}
      onHide={toggleClose}
      animation={false}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Heading label={'お取引支店選択'} size={'m'} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Heading label="支店一覧" size={'s'} />
        <table className="modal-table">
          <tbody>
            <tr>
              {Object.values(office_list).map((value: any, index: number) => {
                return (
                  <td onClick={() => popupClick(value)} key={index}>
                    {value.name}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
        <Messages valid_msg={message} />
      </Modal.Body>
    </Modal>
  );
};

export default SelectOffice;
